export const obtenerFechaActual = () => {
  const hoy = new Date();

  const año = hoy.getFullYear();
  const mes = String(hoy.getMonth() + 1).padStart(2, "0"); // Agrega cero si es necesario
  const dia = String(hoy.getDate()).padStart(2, "0"); // Agrega cero si es necesario

  return `${año}-${mes}-${dia}`;
};
